
export class VersionedEntityStatus {
    static DRAFT = "DRAFT";
    static CURRENT = "CURRENT";
    static ARCHIVED = "ARCHIVED";
}